<template>
    <Modal v-model="show"
        :width="800"
        :footer-hide="true"
        title="报损明细"
        class-name="vertical-center-modal"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Form label-position="top"
                class="small-form">
                <Row :gutter="16">
                    <Col span="12">
                    <Row :gutter="16">
                        <Col span="8">
                        <FormItem label="单号">
                            <Input :value="record.curSaleWarehouseStoreDiscardRecordBillCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="8">
                        <FormItem label="制单时间">
                            <Input :value="formatDateTimeString(record.curSaleWarehouseStoreDiscardRecordCreateAt)"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="8">
                        <FormItem label="制单人">
                            <Input :value="record.userPersonName"
                                readonly></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                        <FormItem label="报损备注:">
                            <Input :value="record.curSaleWarehouseStoreDiscardRecordRemark"
                                type="textarea"
                                :rows="4"
                                readonly></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    </Col>
                    <Col span="12">
                    <Row :gutter="16">
                        <Col span="24">
                        <FormItem label="报损视频:">
                            <video ref="videoElement"
                                width="320"
                                height="240"
                                controls>
                                <source src=""
                                    type="video/mp4">
                            </video>
                        </FormItem>
                        </Col>

                    </Row>
                    </Col>
                </Row>
            </Form>
            <Row :gutter="16"
                class="row-margin-top-15">
                <Col span="24">
                <Table ref="mainTable"
                    size="small"
                    :columns="mainTable.columns"
                    :data="record.discardProducts"
                    highlight-row
                    stripe
                    border />
                </Col>
            </Row>
        </Card>

    </Modal>

</template>

<script>
import { formatDateTimeString } from '@/libs/logic';
import { getImageSrc } from '@/libs/tableRowImageRender';

import { getCurSaleDiscardDetail } from '@/api/modules/warehouse-management/warehouse';

export default {
    name: 'CurSaleWarehouseDiscardDetail',
    data() {
        return {
            show: false,
            innerSpin: false,
            discardUuid: '',
            record: {
                curSaleWarehouseStoreDiscardRecordUuid: '',
                curSaleWarehouseStoreDiscardRecordBillCode: '',
                curSaleWarehouseStoreDiscardRecordRemark: '',
                curSaleWarehouseStoreDiscardRecordVideoJson: '',
                curSaleWarehouseStoreDiscardRecordCreateAt: '',
                userPersonName: '',
                discardProducts: []
            },
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '仓库', key: 'warehouseName', align: 'center' },
                    { title: '产品编号', key: 'productCode', width: 80, align: 'center' },
                    { title: '产品名称', key: 'productName', align: 'center' },
                    { title: '批次', key: 'warehouseStoreJournalProductStoreBatchCode', width: 80, align: 'center' },
                    { title: '报损量', key: 'warehouseStoreJournalAmount', width: 80, align: 'center' },
                    { title: '报损类型', key: 'warehouseStoreJournalType', align: 'center' }
                ]
            }
        };
    },
    mounted() {

    },
    methods: {
        formatDateTimeString,
        getImageSrc,
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(discardUuid) {
            this.discardUuid = discardUuid;
            this.show = true;
        },
        init() {
            if (this.discardUuid) {
                this.innerSpin = true;
                getCurSaleDiscardDetail(this.discardUuid).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.record = Object.assign(this.record, res.data);

                        const videoElement = this.$refs.videoElement;
                        videoElement.src = this.getImageSrc(this.record.curSaleWarehouseStoreDiscardRecordVideoJson);
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        }
    }
};
</script>

<style scoped>
</style>
